import { useEffect, useState } from "react";

const KEY = "pw-cookie-consent";
const EVT = "pw-consent";

export const getConsent = () => localStorage.getItem(KEY);

export function setConsent(v) {
  if (v) localStorage.setItem(KEY, v); else localStorage.removeItem(KEY);
  window.dispatchEvent(new Event(EVT));
  if (v === "rejected" && document.getElementById("adsense-script")) window.location.reload();
}

export function useConsent() {
  const [c, setC] = useState(getConsent);
  useEffect(() => {
    const f = () => setC(getConsent());
    window.addEventListener(EVT, f);
    return () => window.removeEventListener(EVT, f);
  }, []);
  return c;
}
